import { B2B_PURCHASE_HISTORY_PAGE, CASHSTART_RELOAD_GIFT_CARD_PAGE_URL, RELOAD_GIFT_CARD_PAGE_URL, } from '../constants/links';
import { currentYear, listOfMonths } from '../constants/date';
import { getHost } from './general';
import { OrangePayCardBrandFilterValue, } from '../components/addcreditcard/credit-card-form/constants';
import { getCustomerIp } from './customer';
import { getCookie } from './cookies';
export const expirationMonthValues = listOfMonths.map((month, ind) => {
    const count = ind + 1;
    const value = count < 10 ? '0' + count : count.toString();
    return {
        label: month,
        value,
    };
});
export const expirationYearValues = new Array(20)
    .fill(currentYear)
    .map((year, ind) => {
    const nextYear = year + ind;
    return {
        label: nextYear.toString(),
        value: nextYear.toString(),
    };
});
export const redirectToOrderHistoryWithSearch = (requestSearchSelectorValue, requestSearchCriteria) => {
    const params = {
        requestSearchSelectorValue,
        requestSearchCriteria,
    };
    const searchParams = new URLSearchParams(params);
    window.location.assign(`${getHost()}${B2B_PURCHASE_HISTORY_PAGE}?${searchParams.toString()}`);
};
export const getNewPageNumber = (currentPageNumber, totalPages, paymentsOnCurrentPage) => {
    const isLastPage = currentPageNumber > 1 && currentPageNumber === totalPages;
    const isLastPaymentOnPage = paymentsOnCurrentPage === 1;
    return isLastPaymentOnPage && isLastPage
        ? currentPageNumber - 1
        : currentPageNumber;
};
export const getFormattedKeytag = (card) => {
    const keytagNumber = card === null || card === void 0 ? void 0 : card.cardNumber;
    if (keytagNumber.length !== 16) {
        return null;
    }
    const formattedNumber = keytagNumber.slice(0, 4) +
        '-' +
        keytagNumber.slice(4, 8) +
        '-' +
        keytagNumber.slice(8, 12) +
        '-' +
        keytagNumber.slice(12, 16);
    return formattedNumber;
};
export const getPaymentsErrorCode = (error) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ((_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.paymentCards) === null || _c === void 0 ? void 0 : _c.errors[0]) === null || _d === void 0 ? void 0 : _d.errorCode) ||
        ((_h = (_g = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.errorCode);
};
export const getPaymentsErrorMessage = (error) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ((_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.paymentCards) === null || _c === void 0 ? void 0 : _c.errors[0]) === null || _d === void 0 ? void 0 : _d.errorMessage) ||
        ((_h = (_g = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.errorMessage);
};
export const redirectToReloadGiftCardPage = (useNewReloadUrl) => {
    window.location.assign(useNewReloadUrl
        ? RELOAD_GIFT_CARD_PAGE_URL
        : CASHSTART_RELOAD_GIFT_CARD_PAGE_URL);
};
export const hasNoPaymentCards = (tender) => {
    if (!tender)
        return true;
    return tender.paymentCards.length === 0;
};
const showExpirationArray = [
    { BRAND: 'HDMC', SHOW_EXPIRATION: false },
    { BRAND: 'PROX', SHOW_EXPIRATION: false },
    { BRAND: 'HDCOM', SHOW_EXPIRATION: false },
    { BRAND: 'HDCON', SHOW_EXPIRATION: false },
    { BRAND: 'VISA', SHOW_EXPIRATION: true },
    { BRAND: 'MA', SHOW_EXPIRATION: true },
    { BRAND: 'AMEX', SHOW_EXPIRATION: true },
    { BRAND: 'DISC', SHOW_EXPIRATION: true },
    { BRAND: 'PROP', SHOW_EXPIRATION: true }, // PROPURCHASE
];
export const shouldShowCardExpirationWithBrand = (brand) => {
    var _a;
    const card = showExpirationArray.find((cc) => cc.BRAND === brand);
    return (_a = card === null || card === void 0 ? void 0 : card.SHOW_EXPIRATION) !== null && _a !== void 0 ? _a : true;
};
export const creditCardHasMandatoryFieldsForHDPassEnroll = (card) => {
    var _a, _b;
    if (!card || !card.billingAddress)
        return false;
    const { addressId, addressLine1, postalCode, stateCode, cityName } = card.billingAddress;
    // Common mandatory properties
    const hasCommonMandatoryProperties = addressId !== '' &&
        (addressLine1 === null || addressLine1 === void 0 ? void 0 : addressLine1.length) > 0 &&
        card.cardHolderName &&
        card.cardNumberLast4.length > 0 &&
        (postalCode === null || postalCode === void 0 ? void 0 : postalCode.length) > 0 &&
        (stateCode === null || stateCode === void 0 ? void 0 : stateCode.length) > 0 &&
        (cityName === null || cityName === void 0 ? void 0 : cityName.length) > 0;
    // Additional mandatory properties if card brand requires expiration
    const requiresExpiration = shouldShowCardExpirationWithBrand(card.cardBrand);
    const hasExpirationProperties = requiresExpiration
        ? ((_a = card.cardExpiryMonth) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = card.cardExpiryYear) === null || _b === void 0 ? void 0 : _b.length) > 0
        : true;
    return !!hasCommonMandatoryProperties && hasExpirationProperties;
};
const ccHasMandatoryFieldsForEnrollment = (card) => {
    var _a, _b;
    if (!card || !card.billingAddress)
        return false;
    const { addressId, addressLine1, postalCode, stateCode, cityName } = card.billingAddress;
    // Common mandatory properties
    const hasCommonMandatoryProperties = addressId !== '' &&
        (addressLine1 === null || addressLine1 === void 0 ? void 0 : addressLine1.length) > 0 &&
        card.cardHolderName &&
        card.cardNumberLast4.length > 0 &&
        (postalCode === null || postalCode === void 0 ? void 0 : postalCode.length) > 0 &&
        (stateCode === null || stateCode === void 0 ? void 0 : stateCode.length) > 0 &&
        (cityName === null || cityName === void 0 ? void 0 : cityName.length) > 0;
    // Additional mandatory properties if card brand requires expiration
    const requiresExpiration = shouldShowCardExpirationWithBrand(card.cardBrand);
    const hasExpirationProperties = requiresExpiration
        ? ((_a = card.cardExpiryMonth) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = card.cardExpiryYear) === null || _b === void 0 ? void 0 : _b.length) > 0
        : true;
    return !!hasCommonMandatoryProperties && hasExpirationProperties;
};
export const mapAddCreditCardToRequestModel = (formValuesAddCard, { cardDetails, cardReference, posEntryMode }, sessionUuid) => {
    var _a, _b;
    const { cardNickName, cardHolderName, isDefault, addressLine1, addressLine2, zipCode, cityState, isHDWalletFlow, } = formValuesAddCard;
    const { expirationMonth, expirationYear, reportPaymentMethodCode, accountNumberXref, } = cardDetails;
    const buyerId = cardDetails.authorizedBuyerID;
    const [cityName, stateCode] = cityState.split(', ');
    const cardBrand = OrangePayCardBrandFilterValue[cardDetails.reportPaymentMethodCode].toUpperCase();
    const avoidSendExpDate = cardBrand === 'HDCOM' || cardBrand === 'HDCON' || Boolean(buyerId);
    const phoneNumber = ((_a = formValuesAddCard.primaryPhone) === null || _a === void 0 ? void 0 : _a.number)
        ? (_b = formValuesAddCard.primaryPhone) === null || _b === void 0 ? void 0 : _b.number.replace(/-/g, '')
        : undefined;
    return {
        cardNickName,
        cardHolderName,
        cardType: 'cc',
        cardBrand,
        isDefault,
        isActionSetAsDefault: isDefault,
        buyerId,
        customerIp: getCustomerIp(),
        forterToken: getCookie('forterToken', document.cookie) || '',
        enrollHDWallet: isHDWalletFlow ? 'Y' : 'N',
        cardExpiryMonth: avoidSendExpDate ? undefined : expirationMonth,
        cardExpiryYear: avoidSendExpDate ? undefined : expirationYear,
        xrefCardNumber: accountNumberXref,
        reportPaymentMethodCode,
        posEntryMode,
        sessionUuid,
        billingAddress: {
            stateCode,
            countryCode: 'US',
            addressLine1,
            addressLine2: addressLine2 || null,
            postalCode: zipCode,
            cityName,
            phoneNumber,
        },
        cardReference,
        cardDetails,
    };
};
export const mapHDWalletAddedCreditCardToRequestModel = (cardFormValues, paymentId, { cardDetails, cardReference, posEntryMode }) => {
    const buyerId = cardDetails.authorizedBuyerID;
    const [cityName, stateCode] = cardFormValues.cityState.split(', ');
    const cardBrand = OrangePayCardBrandFilterValue[cardDetails.reportPaymentMethodCode].toUpperCase();
    const avoidSendExpDate = cardBrand === 'HDCOM' || cardBrand === 'HDCON' || Boolean(buyerId);
    const { cardNickName, cardHolderName, addressLine1, addressLine2, zipCode, cardExpiryMonth, cardExpiryYear, } = cardFormValues;
    return {
        paymentCardRequest: {
            paymentCard: {
                paymentId,
                cardNickName,
                cardExpiryMonth: avoidSendExpDate ? undefined : cardExpiryMonth,
                cardExpiryYear: avoidSendExpDate ? undefined : cardExpiryYear,
                cardHolderName,
                posEntryMode,
                billingAddress: {
                    stateCode,
                    countryCode: 'US',
                    addressLine1,
                    addressLine2: addressLine2 || null,
                    postalCode: zipCode,
                    cityName,
                },
                customerIp: getCustomerIp(),
                forterToken: getCookie('forterToken', document.cookie) || '',
                cardDetails,
                cardReference,
            },
        },
    };
};
export const checkExpiredCard = (expiryMonth, expiryYear) => {
    const currentDate = new Date().getTime();
    const selectedDate = new Date(+expiryYear, +expiryMonth).getTime();
    return currentDate > selectedDate;
};
export const createBillingAddressObject = (values) => {
    var _a;
    const [city, state] = values.cityState.split(', ');
    return {
        addressLine1: values === null || values === void 0 ? void 0 : values.addressLine1,
        addressLine2: (_a = values === null || values === void 0 ? void 0 : values.addressLine2) !== null && _a !== void 0 ? _a : '',
        city,
        state,
        zipCode: values === null || values === void 0 ? void 0 : values.zipCode,
    };
};
export function hasBillingAddress(card) {
    if ('billingAddress' in card) {
        return ccHasMandatoryFieldsForEnrollment(card);
    }
    return false;
}
export const getFormValuesFromAddressSelected = (addressSelected) => {
    return {
        addressLine1: (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.addressLine1) || '',
        addressLine2: addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.addressLine2,
        cityState: (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.city) + ', ' + (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.state),
        zipCode: (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.zipCode) || '',
        primaryPhone: {
            number: (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.primaryPhone) || '',
        },
    };
};
